<template>
  <div class="columns is-vcentered has-bg-white is-multiline is-gapless is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right-xsmall">
    <div class="column is-12 columns is-gapless"
      :class="[canDrag ? '' : 'is-padding-left-xsmall']" 
    >
      <div v-if="canDrag" class="column is-narrow w50p"></div>
      <div class="column">
        <label for="'documentFileName-' + document.path" class="label">Nom du fichier</label>
      </div>
    </div>
    <div class="column is-narrow w50p has-cursor-grab has-text-centered" v-if="canDrag">
      <i class="fal fa-grip-lines"></i>
    </div>
    <div class="column is-padding-top-xxsmall"
      :class="[canDrag ? '' : 'is-padding-left-xsmall']"
    >
      <div class="field has-addons">
        <p class="control is-expanded">
          <v-input :id="'documentFileName-' + document.path"
                   :name="'documentFileName-' + document.path"
                   :model="document.filename"
                   :errors-bag="errors"
                   :fromFlux="fromFlux"
                   :disabled="!canEdit"
                   data-vv-value-path="val"
                   data-vv-as="Nom du fichier"
                   label=""
                   :classes="''"
                   v-validate="'required|min:2'"
                   @input="val => updateName(val)">
          </v-input>
        </p>
        <p class="control" v-if="canEdit && editName && !askDelete">
          <a class="button is-square is-success" @click="updateDocument">
            <span class="is-small"><i class="fal fa-save"></i></span>
          </a>
        </p>
        <p class="control" v-if="canEdit && !askDelete">
          <a class="button is-square is-grey is-inverted is-border" @click="askDelete = true">
            <i class="fal fa-trash-alt"></i></a>
        </p>
        <p class="control" v-if="!askDelete">
          <a class="button is-square is-grey is-inverted is-border tooltip"
            :href="document.path" target="_blank" :download="document.filename" data-tooltip="Télécharger">
            <i class="fal fa-download"></i>
          </a>
        </p>
      </div>
    </div>
    <div v-if="canEditDisplay && !askDelete" class="column is-narrow w150p is-padding-left-xsmall is-padding-top-xxsmall">
      <input :id="'document_display-' + index + document.path" type="checkbox"
            :name="'document_display-' + index + document.path"
            class="switch is-success is-rounded" v-model="displayDoc"
            @input="updateDisplay">
      <label :for="'document_display-' + index + document.path">
        <span class="is-size-6 has-text-grey">{{displayDoc ? 'Visible par tous' : 'Masqué'}}</span>
      </label>
    </div>

    <div class="column is-narrow is-padding-left-xsmall is-padding-top-xxsmall" v-if="askDelete">
      <div class="field has-addons">
        <div class="control">
          <a @click="deleteDocument" class="button is-small is-danger">
            <span>Confirmer suppression</span>
          </a>
        </div>
        <div class="control">
          <a @click="askDelete = false" class="button is-small is-white is-border is-square ">
            <span class="icon is-small">
              <i class="fas fa-times is-size-5"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ViewFileItem',
    data () {
      return {
        editName: false,
        askDelete: false,
        displayDoc: false
      }
    },
    props: {
      document: {
        type: Object,
        default: () => {}
      },
      canDrag: {
        type: Boolean,
        default: true
      },
      index: {
        type: Number,
        default: 0
      },
      fromFlux: {
        type: Boolean,
        default: false
      },
      canEdit: {
        type: Boolean,
        default: false
      },
      canEditDisplay: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      updateName (val) {
        this.editName = true
        this.document.filename = val
      },
      updateDisplay (val) {
        this.displayDoc = !this.displayDoc
        this.updateDocument()
      },
      updateDocument () {
        this.editName = false
        this.document.display = this.displayDoc
        this.$emit('update', {document: this.document, index: this.index})
      },
      deleteDocument () {
        this.askDelete = false
        this.$emit('delete', {index: this.index})
      }
    },
    created () {
      this.displayDoc = this.document.display
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/ViewFileItem.vue